module.exports = __webpack_public_path__ + "static/media/Icon-08@2x.f9b27e97.png";